module.exports = __webpack_public_path__ + "static/media/remove.55f2bfc1.png";